import Vue from 'vue';
import Vuex from 'vuex';
import { db } from '@/main';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    jobs: [],
    papers: [],
    settings: {}
  },
  mutations: {
    //call to firebase
    setSettings: state => {
      let items = {};

      let doc = db.collection('prices').doc('ink');

      let observer = doc.onSnapshot(
        docSnapshot => {
          //console.log('Received doc snapshot:', docSnapshot.data());
          state.settings = docSnapshot.data();
          //console.log(state.settings);
        },
        err => {
          console.log(`Encountered error: ${err}`);
        }
      );
      // console.log('state.jobs:', state.jobs);
      //state.settings = items;
    },
    setJobs: state => {
      let items = [];

      db.collection('jobs')
        .orderBy('newPrinted')
        .onSnapshot(snapshot => {
          items = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          //console.log('items:', items);
          state.jobs = items;
        });
      //console.log('state.jobs:', state.jobs);
      state.jobs = items;
    },
    getPapers: state => {
      let items = [];

      db.collection('prices')
        .doc('papers')
        .collection('papers')
        // .orderBy('printed', 'desc')
        .onSnapshot(snapshot => {
          items = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          state.papers = items;
        });

      state.papers = items;
    }
  },
  actions: {
    // call mutation
    getJobs: context => {
      context.commit('setJobs');
    },
    getSettings: context => {
      context.commit('setSettings');
    },
    getPapers: context => {
      context.commit('getPapers');
    }
  },
  getters: {
    // call action and transfer

    getSettings: state => {
      return state.settings;
    },
    getJobs: state => {
      return state.jobs.sort((jobA, jobB) => {
        return jobA.printed < jobB.printed;
      });
    },
    getJob(state) {
      return jobId => {
        return state.jobs.find(job => {
          return job.id == jobId;
        });
      };
    },
    getPapers(state) {
      return state.papers;
    },
    getPaper(state) {
      return paperId => {
        return state.papers.find(paper => {
          return paper.id == paperId;
        });
      };
    }
  }
});
